var _defs, _ellipse, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtilarIkonu6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#55c595;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xC7al\u0131\u015Fma Y\xFCzeyi 43 kopyamdpi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 743.14,
    cy: 442.36,
    rx: 288.72,
    ry: 192.4,
    transform: "matrix(0.58, -0.82, 0.82, 0.58, -46.27, 795.59)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M668.68,851.59s-139-305.89,139-519.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M627,707.91s-231.73-176.12-9.27-407.85c0,0,129-111.82,279.36-111.74a27.91,27.91,0,0,1,25.35,16c20.13,43,65.22,171.64-17.35,336.78,0,0-46.35,129.77-203.93,166.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.75,601.31S491.18,328.19,209,323.08a27.78,27.78,0,0,0-27.77,22.57c-6.63,35.26-21.68,110.61,10.85,189.3C211,580.54,246.4,617.8,291.51,637.76c33.72,14.91,82.53,29.1,150.07,33.07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.81,763.53s-73.9-88.68-149.11-127.47c-35.94-18.54-67.2-45.5-87-80.78-13.92-24.83-26.49-57-32.73-97.64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtilarIkonu6);
export default __webpack_public_path__ + "static/media/artilarIkonu6.5a0b92998a07232266dedf2d2c30771c.svg";
export { ForwardRef as ReactComponent };